import { Injectable, Inject } from '@angular/core';

import { DataService } from '../shared-service/data.service';
import { BaseService } from '../shared-service/base.service';
import { DeepLinkRouteData } from './deeplink-route-data';


@Injectable()
export class DeeplinkService {

    constructor(public bs: BaseService, private dataService: DataService) {
        this.bs.log('info', "Loaded DeeplinkService");
    }

    updateStoreData(key: PropertyKey, data: Object) {
        return this.dataService.setStoreData(key, data);
    }

    getStoreData(key: PropertyKey) {
        return this.dataService.getDataStoreData(key);
    }

    getDeeplinkDetailFromServer(body: Object, key: PropertyKey) {
        let promise = new Promise((resolve, reject) => {
            let controllerMethod:any;
            controllerMethod = 'DeepLink/GetDeepLinkDetail';
            this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
                this.bs.log('info', "Succes in getting result from " + controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error', err);
                this.bs.logout();
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);

            }).catch((exception) => {
                this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    getLoginDetailFromServer(body: Object, key: PropertyKey, loginType: PropertyKey) {
        let promise = new Promise((resolve, reject) => {
            let controllerMethod:any;
            controllerMethod = 'Logon/ValidateLogin';

            this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
                this.bs.log('info', "Succes in getting result from " + controllerMethod);
                resolve(data);
            }, (err) => {
                alert((err.error).Message);
                this.bs.log('error', err);
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);

            }).catch((exception) => {
                this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    GetLearningItemDetail(body: Object, key: PropertyKey) {
        let promise = new Promise((resolve, reject) => {
            let controllerMethod:any;
            controllerMethod = 'DeepLink/GetLearningItemDetail';
            this.dataService.doPostWithPromise(key, controllerMethod, body).then((data) => {
                this.bs.log('info', "Succes in getting result from " + controllerMethod);
                resolve(data);
            }, (err) => {
                this.bs.log('error', err);
                //this.bs.logout();
                this.bs.errorHandler((err.error).Message);
                reject((err.error).Message);

            }).catch((exception) => {
                this.bs.errorHandler(exception);
                reject(exception);
            });
        });
        return promise;
    };

    SetDeepLinkNavigationData(deepLinkRouteData: DeepLinkRouteData) {
        this.bs.IsDeepLinkActive = true;
        this.bs.setCurrentModulePath(this.bs.loadModulePath(deepLinkRouteData.ModuleName));
        this.bs.DeepLinkMenuItemKey = deepLinkRouteData.MenuKey;
        this.bs.DeepLinkSubmenuItemKey = deepLinkRouteData.SubMenuKey;
    }

    PrepareDeepLinkData(moduleName: string, mappedRoute: string, menuKey: string, subMenuKey: string): DeepLinkRouteData {
        let deepLinkRouteData = new DeepLinkRouteData();
        deepLinkRouteData.ModuleName = moduleName;
        deepLinkRouteData.MappedRoute = mappedRoute;
        deepLinkRouteData.MenuKey = menuKey;
        deepLinkRouteData.SubMenuKey = subMenuKey;
        return deepLinkRouteData;
    }
}

